import { Mail, Clock, ShieldCheck } from "lucide-react";
import ContactForm from "@/components/ContactForm";

export default function Contact() {
  return (
    <main data-testid="contact-page" className="bg-[#040812]">
      <section className="pt-32 md:pt-40 pb-16 md:pb-20 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <span className="overline">Schedule a Consultation</span>
          <h1 className="mt-6 font-display text-white text-5xl md:text-6xl lg:text-7xl tracking-tighter font-light leading-[1.02] max-w-4xl">
            Speak with a{" "}
            <span className="text-red-500">founding partner</span>.
          </h1>
          <p className="mt-8 text-slate-400 text-base md:text-lg max-w-2xl leading-relaxed">
            Tell us about the engagement. A member of the founding team will
            respond within one business day. All submissions are treated as
            confidential.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4 space-y-6">
            <a
              href="mailto:Info@srimansolutions.com"
              data-testid="contact-email-link"
              className="block bg-[#0B132B]/50 border border-white/10 p-8 hover-lift group"
            >
              <Mail size={18} className="text-red-500" strokeWidth={1.5} />
              <div className="overline mt-6">Direct email</div>
              <div className="mt-3 font-display text-white text-xl tracking-tight group-hover:text-red-400 transition-colors">
                Info@srimansolutions.com
              </div>
              <div className="mt-3 text-slate-500 text-sm">
                Preferred for existing clients and NDA-covered inquiries.
              </div>
            </a>

            <div className="bg-[#0B132B]/50 border border-white/10 p-8">
              <Clock size={18} className="text-red-500" strokeWidth={1.5} />
              <div className="overline mt-6">Response window</div>
              <div className="mt-3 font-display text-white text-xl tracking-tight">
                Within 1 business day
              </div>
              <div className="mt-3 text-slate-500 text-sm">
                Global coverage across APAC, EMEA and the Americas.
              </div>
            </div>

            <div className="bg-[#0B132B]/50 border border-white/10 p-8">
              <ShieldCheck size={18} className="text-red-500" strokeWidth={1.5} />
              <div className="overline mt-6">Confidentiality</div>
              <div className="mt-3 text-slate-300 text-sm leading-relaxed">
                Submissions are stored on infrastructure we operate. Mutual NDAs
                available on request before disclosure of sensitive detail.
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ContactForm />
          </div>
        </div>
      </section>
    </main>
  );
}
